export const PRODUCT = 'C'
